import React, { useRef } from 'react';
import { Form, Formik, FormikValues } from 'formik';
import * as Yup from 'yup';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import { ProductTemplate } from '../Product.interface';
import FormikGrid from '../../../common/formik/FormikGrid';
import FormikTextField from '../../../common/formik/FormikTextField';
import FormikButton from '../../../common/formik/FormikButton';

export interface ProductTemplateRenameDialogProps {
  open: boolean;
  template: ProductTemplate;
  onCancel?: () => void;
  onUpdate?: (template: Partial<ProductTemplate>) => void;
}

const ProductTemplateRenameDialog: React.FC<
  ProductTemplateRenameDialogProps
> = props => {
  const { open, template, onCancel, onUpdate } = props;
  const formikRef = useRef<FormikValues>();
  return (
    <Dialog open={open}>
      <Formik
        innerRef={(formik: any) => (formikRef.current = formik)}
        initialValues={{ name: template.name } as Partial<ProductTemplate>}
        validationSchema={Yup.object({
          name: Yup.string().required('Template name is required.')
        })}
        onSubmit={(dto: Partial<ProductTemplate>) => {
          onUpdate?.(dto);
        }}
      >
        <Form autoComplete='off'>
          <DialogTitle>Rename Template</DialogTitle>
          <DialogContent>
            <FormikGrid>
              <FormikTextField
                autoFocus
                type='text'
                name='name'
                label='Template Name'
              />
            </FormikGrid>
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancel}>Cancel</Button>
            <FormikButton>Rename</FormikButton>
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
};
export default ProductTemplateRenameDialog;
